import { render, staticRenderFns } from "./UserChangePermissionsModal.vue?vue&type=template&id=5fa3b858&"
import script from "./UserChangePermissionsModal.vue?vue&type=script&lang=ts&"
export * from "./UserChangePermissionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserChangePermissionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports